const model = {
  text: null,
  category: null
};

const fields = [
  {
    path: "text",
    type: "text",
    label: "Goal name"
  }
];

const tableFields = [
  {
    key: "text",
    label: "Goal",
    sortable: true
  }
];

const info = {
  id: "goals",
  db: "goals",
  name: "Goals",
  single: "Goal",
  fields: tableFields
};

export {model, fields, info};
